import ContentLoader from 'react-content-loader';

const ProductLoader = (props: any) => (
    <div className="rounded-[10px] bg-white p-4 shadow-productCard">
        <ContentLoader
            speed={2}
            width={'100%'}
            height={'100%'}
            viewBox="0 0 480 760"
            backgroundColor="#ececec"
            foregroundColor="#d6d6d6"
            {...props}>
            <rect x="0" y="0" rx="10" ry="10" width="100%" height="380" />
            <rect x="0" y="400" rx="8" ry="8" width="70%" height="22" />
            <rect x="0" y="434" rx="8" ry="8" width="20%" height="16" />
            <rect x="0" y="462" rx="10" ry="10" width="40%" height="32" />
            <rect x="0" y="510" rx="100" ry="100" width="80" height="80" />
            <rect x="96" y="510" rx="100" ry="100" width="80" height="80" />
            <rect x="192" y="510" rx="100" ry="100" width="80" height="80" />
            <rect x="0" y="616" rx="5" ry="5" width="90%" height="16" />
            <rect x="0" y="640" rx="5" ry="5" width="45%" height="16" />
            <rect x="0" y="672" rx="5" ry="5" width="40%" height="16" />
            <rect x="0" y="700" rx="5" ry="5" width="30%" height="16" />
            <rect x="75%" y="642" rx="100" ry="100" width="100" height="100" />
        </ContentLoader>
    </div>
);

export default ProductLoader;

export const ProductLoaderHorizontal = (props: any) => (
    <div className="rounded-[10px] bg-white p-4 shadow-productCard">
        <ContentLoader
            speed={2}
            width={'100%'}
            height={'100%'}
            viewBox="0 0 480 380"
            backgroundColor="#ececec"
            foregroundColor="#d6d6d6"
            {...props}>
            <rect x="0" y="30" rx="10" ry="10" width="200" height="330" />
            <rect x="210" y="40" rx="12" ry="12" width="260" height="30" />
            <rect x="210" y="80" rx="12" ry="12" width="240" height="30" />
            <rect x="210" y="120" rx="10" ry="10" width="100" height="16" />
            <rect x="210" y="148" rx="10" ry="10" width="180" height="26" />
            <rect x="210" y="184" rx="100" ry="100" width="40" height="40" />
            <rect x="260" y="184" rx="100" ry="100" width="40" height="40" />
            <rect x="310" y="184" rx="100" ry="100" width="40" height="40" />
            <rect x="210" y="240" rx="5" ry="5" width="260" height="16" />
            <rect x="210" y="260" rx="5" ry="5" width="220" height="16" />
            <rect x="210" y="284" rx="5" ry="5" width="120" height="16" />
            <rect x="210" y="310" rx="5" ry="5" width="100" height="16" />
            <rect x="400" y="300" rx="100" ry="100" width="60" height="60" />
        </ContentLoader>
    </div>
);
